module.exports = __webpack_public_path__ + "img/L_5C.f577216d.png";